var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography, useTheme, CircularProgress, } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { packages } from '../../constants/offerValues';
import { DownloadIcon } from '../atoms/Icons';
import { validURL } from '../../utils/format';
import TranslateButton from '../organisms/ForumMessages/TranslateButton';
import { useTypicaTranslation } from '../../hooks/useTypicaTranslation';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 16px 12px 56px;\n  display: flex;\n  flex-wrap: wrap;\n\n  .field {\n    margin-right: 32px;\n    margin-bottom: 8px;\n    line-height: 2;\n\n    &.long-text {\n      display: block;\n      margin-top: 8px;\n      width: 100%;\n    }\n\n    .field-head {\n      font-weight: bold;\n    }\n    .field-body {\n      max-width: 100%;\n      white-space: pre-wrap;\n      word-break: break-all;\n\n      svg {\n        height: 100%;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  &.sp {\n    padding: 3px 6px;\n\n    .field {\n      display: inline-flex;\n      margin-right: 0;\n      flex-basis: 100%;\n      justify-content: space-between;\n\n      &.long-text {\n        flex-direction: column;\n      }\n\n      .field-head {\n        display: flex;\n        font-weight: normal;\n\n        &::after {\n          display: flex;\n          content: ':';\n          margin-right: 5px;\n        }\n      }\n      .field-body {\n        display: flex;\n        white-space: pre-wrap;\n        word-break: break-all;\n        max-width: 100%;\n      }\n    }\n  }\n"], ["\n  padding: 0 16px 12px 56px;\n  display: flex;\n  flex-wrap: wrap;\n\n  .field {\n    margin-right: 32px;\n    margin-bottom: 8px;\n    line-height: 2;\n\n    &.long-text {\n      display: block;\n      margin-top: 8px;\n      width: 100%;\n    }\n\n    .field-head {\n      font-weight: bold;\n    }\n    .field-body {\n      max-width: 100%;\n      white-space: pre-wrap;\n      word-break: break-all;\n\n      svg {\n        height: 100%;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  &.sp {\n    padding: 3px 6px;\n\n    .field {\n      display: inline-flex;\n      margin-right: 0;\n      flex-basis: 100%;\n      justify-content: space-between;\n\n      &.long-text {\n        flex-direction: column;\n      }\n\n      .field-head {\n        display: flex;\n        font-weight: normal;\n\n        &::after {\n          display: flex;\n          content: ':';\n          margin-right: 5px;\n        }\n      }\n      .field-body {\n        display: flex;\n        white-space: pre-wrap;\n        word-break: break-all;\n        max-width: 100%;\n      }\n    }\n  }\n"])));
var TranslationTypography = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    border-left: 4px solid;\n    margin-left: 16px;\n    padding-left: 16px;\n  }\n"], ["\n  && {\n    border-left: 4px solid;\n    margin-left: 16px;\n    padding-left: 16px;\n  }\n"])));
var OrderedItemDetail = function (_a) {
    var orderedItem = _a.orderedItem;
    var t = useTranslation().t;
    var theme = useTheme();
    var mode = useMediaQuery(theme.breakpoints.down('md')) ? 'sp' : 'pc';
    var offer = orderedItem.offer;
    var defaultRenderHead = React.useCallback(function (field) { return t("params.offer.".concat(field)); }, [t]);
    var defaultRenderBody = React.useCallback(function (field) { return offer[field]; }, [offer]);
    var renderMinOrder = React.useCallback(function () { return "".concat(orderedItem.minOrder, "Kg"); }, [orderedItem]);
    var renderBagSize = React.useCallback(function () { return "".concat(orderedItem.bagSize, "Kg"); }, [orderedItem]);
    var renderPackage = React.useCallback(function () { return packages[offer.package]; }, [offer]);
    var renderCuppingScoreAverage = React.useCallback(function () { return (offer.cuppingScoreAverage ? offer.cuppingScoreAverage : '-'); }, [offer]);
    var renderDownloadLink = React.useCallback(function () {
        var url = offer.downloadLink ? offer.downloadLink.toString() : '/';
        if (!validURL(url))
            return offer.farm;
        return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer" },
            React.createElement(DownloadIcon, null)));
    }, [offer]);
    var renderProcessingMethod = React.useCallback(function () {
        var content = TranslatableText(offer.processingMethod);
        return content;
    }, [offer]);
    var renderProducerComment = React.useCallback(function () {
        var content = TranslatableText(offer.producerComment);
        return content;
    }, [offer]);
    var renderNote = React.useCallback(function () {
        var content = TranslatableText(offer.note);
        return content;
    }, [offer]);
    var fields = React.useMemo(function () { return [
        { name: 'producerName' },
        { name: 'region' },
        { name: 'district' },
        { name: 'altitude' },
        { name: 'farmSize' },
        { name: 'grade' },
        { name: 'harvestYear' },
        { name: 'harvestMonth' },
        { name: 'minOrder', renderBody: renderMinOrder },
        { name: 'bagSize', renderBody: renderBagSize },
        { name: 'package', renderBody: renderPackage },
        { name: 'purchaseLimit' },
        {
            name: 'cuppingScoreAverage',
            renderBody: renderCuppingScoreAverage,
        },
        {
            name: 'downloadLink',
            renderBody: renderDownloadLink,
        },
        {
            name: 'processingMethod',
            className: 'long-text',
            renderBody: renderProcessingMethod,
        },
        {
            name: 'producerComment',
            className: 'long-text',
            renderBody: renderProducerComment,
        },
        {
            name: 'note',
            className: 'long-text',
            renderBody: renderNote,
        },
    ]; }, [
        renderMinOrder,
        renderBagSize,
        renderPackage,
        renderCuppingScoreAverage,
        renderDownloadLink,
        renderProcessingMethod,
        renderProducerComment,
        renderNote,
    ]);
    var existsFields = fields.filter(function (field) { return offer[field.name]; });
    return (React.createElement(Wrapper, { className: mode },
        React.createElement(Divider, { sx: { mb: 1.5, width: '100%' } }),
        existsFields.map(function (_a) {
            var name = _a.name, className = _a.className, _b = _a.renderHead, renderHead = _b === void 0 ? defaultRenderHead : _b, _c = _a.renderBody, renderBody = _c === void 0 ? defaultRenderBody : _c;
            return (React.createElement("div", { key: name, className: clsx('field', className) },
                React.createElement(Box, { sx: {
                        color: function (theme) { return theme.customPalette.text.primary; },
                        typography: function (theme) { return theme.customTypography.body3; },
                        fontWeight: 500,
                    } }, renderHead(name)),
                React.createElement(Box, { sx: {
                        color: function (theme) { return theme.customPalette.text.secondary; },
                        typography: function (theme) { return theme.customTypography.body3; },
                        wordBreak: 'break-word',
                        whiteSpace: 'pre-wrap',
                    } }, renderBody(name))));
        })));
};
function TranslatableText(text) {
    var _this = this;
    var _a = useTypicaTranslation(), loading = _a.loading, translate = _a.translate;
    var _b = React.useState(), translatedContext = _b[0], setTranslatedContext = _b[1];
    var handleTranslate = React.useCallback(function (language) {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var translation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, translate(text, language)];
                    case 1:
                        translation = _a.sent();
                        if (translation) {
                            setTranslatedContext(translation);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [text, translate]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, null, text),
        translatedContext && (React.createElement(TranslationTypography, null, translatedContext)),
        React.createElement(TranslateButton, { translated: Boolean(translatedContext), onTranslate: handleTranslate }),
        loading && React.createElement(CircularProgress, null)));
}
export default OrderedItemDetail;
var templateObject_1, templateObject_2;
